import {
  BUY_WALLET,
  CHANGE_STATUS_COST_PER_CLICK,
  FETCH_BIDDING,
  ACCEPT_PRIZE,
  VERIFY_BIDDING,
} from "../constants/bidding";

export function fetchBiddings(doctorId: number) {
  return {
    type: FETCH_BIDDING,
    api: true,
    payload: {
      method: "GET",
      url: `/bidding/${doctorId}`,
    },
  };
}

export function changeStatusOrCostPerClick(doctorId: number, status: boolean, price: number) {
  return {
    type: CHANGE_STATUS_COST_PER_CLICK,
    api: true,
    payload: {
      method: "PUT",
      url: `/bidding/${doctorId}`,
      data: { status, costPerClick: price },
    },
  };
}

export function buyWallet(doctorId: number, amount: number, wallet: string = "bidding") {
  return {
    type: BUY_WALLET,
    api: true,
    payload: {
      method: "POST",
      url: `/wallet/${doctorId}/deposit`,
      data: { amount, wallet },
    },
  };
}

export function acceptPrize(doctorId: number) {
  return {
    type: ACCEPT_PRIZE,
    api: true,
    payload: {
      method: "POST",
      url: `/wallet/${doctorId}`,
    },
  };
}

export function verfiybiddingPayment(orderId: number, trackId: number) {
  return {
    type: VERIFY_BIDDING,
    api: true,
    payload: {
      method: "GET",
      url: `/wallet/verify`,
      params: { orderId, trackId },
    },
  };
}
